import axios from 'axios'
import { API_URL } from '@/services/api'
import { getAuthToken } from '@/services/sessionProps'
import { getAccountService } from '@/services/accountService'
import { getAuthService } from '@/services/authService'
import { handleCatch } from '../helpers/axiosHelpers'

axios.defaults.headers.common = {
  Authorization: `Bearer ${getAuthToken()}`,
}

const BandLyricsService = {
  async getBandLyric (bandLyricId) {
    try {
      const response = await axios.get(
        `${API_URL}/api/band_lyrics/${bandLyricId}`
      )

      return response.data
    } catch (error) {
      handleCatch(error)
    }
  },
  async modifyBandLyric (bandLyric) {
    try {
      const response = await axios.patch(
        `${API_URL}/api/band_lyrics/${bandLyric.id}`,
        bandLyric,
        {
          headers: {
            'Content-Type': 'application/merge-patch+json',
          },
        }
      )

      return response.data
    } catch (error) {
      handleCatch(error)
    }
  },
  async createBandLyric (bandLyric, band) {
    const currentBand = band
    try {
      const band = currentBand || await getAccountService().getAccount(
        await getAuthService().getLoggedInKey(),
        false
      )
      const requestData = {
        content: '',
        playlistItems: [],
        title: '',
        ...bandLyric,
        band: band.groupKey,
      }

      return await axios.post(`${API_URL}/api/band_lyrics`, requestData, {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`
        }
      })
    } catch (error) {
      handleCatch(error)
    }
  },

  async createBandLyricPicture (id, pictureUri, order) {
    try {
      const data = await axios.put(`${API_URL}/api/band_lyrics/${id}/lyrics_pictures_create`,
        {
          'src': pictureUri,
          'order': order
        },
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

      return data

    } catch (e) {
      return null
    }
  },
  async getBandLyricPictures (id) {
    try {
      const data = await axios.get(`${API_URL}/api/band_lyrics/${id}/lyrics_pictures`,
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

      return data.data['hydra:member']

    } catch (e) {
      return null
    }
  },

  async deleteBandLyricPictures (id) {
    try {
      const data = await axios.delete(`${API_URL}/api/band_lyrics/${id}/lyrics_pictures_delete`, {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      })

      return data

    } catch (e) {
      return null
    }
  },

  async deleteBandLyricPicture (id) {
    try {
      const data = await axios.delete(`${API_URL}/api/lyrics_pictures/${id}`, {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      })

      return data

    } catch (e) {
      return null
    }
  },

  async deleteBandLyric (id) {
    try {
      const data = await axios.delete(`${API_URL}/api/band_lyrics/${id}`, {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      })

      return data

    } catch (e) {
      return null
    }
  },

  async deleteAllBandLyrics () {
    try {
      const data = await axios.delete(`${API_URL}/api/band_lyrics/band_lyrics_delete_all`, {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      })

      return data

    } catch (e) {
      return null
    }
  },

  async getBandLyricPlaylist (id) {
    try {
      const data = await axios.get(`${API_URL}${id}`, {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      })

      return data.data.playlist

    } catch (e) {
      return null
    }
  },

  async getBandLyricPlaylistName (id) {
    try {
      const data = await axios.get(`${API_URL}${id}`, {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      })

      return data.data.name

    } catch (e) {
      return null
    }
  },

  async getBandLyricTags () {
    try {
      const band = await getAccountService().getAccount(
          await getAuthService().getLoggedInKey(), false)
      const bandId = band.groupKey.slice(11)

      const data = await axios.get(`${API_URL}/api/bands_lyric_tags`, {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
        params : {
          bandId,
        },
      })
      return data.data['hydra:member']
    } catch (e) {
      return null
    }
  },

  async createBandLyricTags (payload) {
    try {
      const data = await axios.post(`${API_URL}/api/lyric_tags`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`
        }
      })
      
      return data
    } catch(e) {
      return null
    }
  },
}

/* eslint-disable import/prefer-default-export */
export function getBandLyricsService () {
  return BandLyricsService
}
